import { render, staticRenderFns } from "./yanShiPage.vue?vue&type=template&id=25bba15e&"
import script from "./yanShiPage.vue?vue&type=script&lang=js&"
export * from "./yanShiPage.vue?vue&type=script&lang=js&"
import style0 from "./yanShiPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports